import gql from 'graphql-tag'

export const SEARCH_EXPO_COMPANIES = gql`
  query SearchExpoCompanies($eventId: String!, $searchTerm: String) {
    searchExpoCompanies(eventId: $eventId, searchTerm: $searchTerm) {
      id
      name
      OIB
    }
  }
`
